export default {
    'WORKERS.SEARCH.PLACEHOLDER': 'Rechercher par nom',
    'WORKER.DETAILS': 'Informations personnelles de la ressource',
    'WORKER.NO.WORKER': 'Pas encore de ressource',
    'WORKER.UNCONFIRMED': 'Utilisateurs non confirmés',
    'WORKER.CONFIRMED': 'Utilisateurs confirmés',
    'WORKER.EMAIL.TAKEN': 'L\'email est déjà utilisé',
    'WORKER.POPUP.SUCCESS.EDIT.MESSAGE': 'Le profil a bien été modifié',
};
